import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

export function LegalLayout({ title, updated, testid, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative bg-white text-brand-navy min-h-screen grain" data-testid={testid}>
      <header className="sticky top-0 z-20 bg-white/90 backdrop-blur-xl border-b border-black/5">
        <div className="flex items-center justify-between px-6 sm:px-10 py-4 max-w-3xl mx-auto">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-brand-link">
            <Logo className="w-7 h-7" />
            <span className="font-heading font-extrabold tracking-[0.14em] text-base">NOT BY WILL</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-home-link"
            className="flex items-center gap-1.5 text-sm text-stone hover:text-brand-navy transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Home
          </Link>
        </div>
      </header>

      <main className="px-6 sm:px-10 py-14">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight mb-3">{title}</h1>
          <p className="text-sm text-stone mb-12">Last updated: {updated}</p>
          <div className="space-y-9 text-[15px] leading-relaxed text-stone">{children}</div>
        </div>
      </main>

      <footer className="border-t border-black/5 px-6 sm:px-10 py-8">
        <div className="max-w-3xl mx-auto flex items-center gap-5 text-sm">
          <Link to="/blog" className="text-stone hover:text-brand-navy transition-colors">Blog</Link>
          <Link to="/privacy" className="text-stone hover:text-brand-navy transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="text-stone hover:text-brand-navy transition-colors">Terms of Use</Link>
        </div>
      </footer>
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      <h2 className="font-heading text-xl font-medium text-brand-navy mb-2.5">{heading}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
